import { DateTime } from "luxon";

const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
]

export const getMonthNameByDate = (date = new Date()) => {
    const _date = new Date(date);
    return months[_date.getMonth()]
}

export const addMonths = (numOfMonths, date = new Date()) => {
    const _date = new Date(date);
    _date.setMonth(_date.getMonth() + numOfMonths);

    return _date;
}

export const addDays = (numOfDays, date = new Date()) => {
    const _date = new Date(date);
    _date.setDate(_date.getDate() + numOfDays);

    return _date;
}

export const setHours = (date = new Date(), hoursValue = 0, minutesValue = 0, secondsValue = 0, msValue = 0) => {
    const _date = new Date(date);
    _date.setHours(hoursValue, minutesValue, secondsValue, msValue);
    return _date;
}

export const toString = (date = new Date()) => {
    const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    const month = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
}

export const isWeekend = (date = new Date()) => {
    const _date = new parseDate(date);
    const dayOfWeek = _date.getDay();
    return dayOfWeek === 5 || dayOfWeek === 6 || dayOfWeek === 0;
}

export const isJuly = (date = new Date()) => {
    const _date = new parseDate(date);
    const month = _date.getMonth() + 1;
    return month === 7;
}

export const getMonthNamesBetweenDates = (startDate = new Date(), endDate = new Date()) => {
    const _startDate = new Date(startDate);
    const _endDate = new Date(endDate);

    if (_startDate.getMonth() === _endDate.getMonth()) {
        return getMonthNameByDate(_startDate);
    }

    return `${getMonthNameByDate(_startDate)} - ${getMonthNameByDate(_endDate)}`;
}

export const getFullYearsBetweenDates = (startDate = new Date(), endDate = new Date()) => {
    const _startDate = new Date(startDate);
    const _endDate = new Date(endDate);

    if (_startDate.getFullYear() === _endDate.getFullYear()) {
        return `${_startDate.getFullYear()}`;
    }

    return `${_startDate.getFullYear()} - ${_endDate.getFullYear()}`;
}

// export const parseDate = (date = new Date()) => {
//     try {
//         const parsedDate = DateTime.fromFormat(date, "yyyy-MM-dd").toJSDate();
//         if (parsedDate && !isNaN(parsedDate)) {
//             return parsedDate;
//         }
//     } catch (error) {}

//     try {
//         const parsedDate = DateTime.fromISO(date).toJSDate()
//         if (parsedDate && !isNaN(parsedDate)) {
//             return parsedDate;
//         }
//     } catch (error) {}

//     try {
//         const parsedDate = DateTime.fromSQL(date).toJSDate();
//         if (parsedDate && !isNaN(parsedDate)) {
//             return parsedDate;
//         }
//     } catch (error) {}

//     try {
//         const parsedDate = DateTime.fromJSDate(date).toJSDate();
//         if (parsedDate && !isNaN(parsedDate)) {
//             return parsedDate;
//         }
//     } catch (error) {}

//     try {
//         const parsedDate = DateTime.fromHTTP(date).toJSDate();
//         if (parsedDate && !isNaN(parsedDate)) {
//             return parsedDate;
//         }
//     } catch (error) {}

//     try {
//         if (!isNaN(new Date(date))){
//             return new Date(date);
//         }
//     } catch (error) {}
// }

const dateFormats = [
    'yyyy-MM-dd HH:mm:ss',           // Formato ISO con hora
    'yyyy-MM-dd HH:mm:ss.SSS',       // Formato ISO con hora y milisegundos
    'yyyy-MM-dd',                    // Formato ISO
    'yyyy-MM-ddTHH:mm:ss',           // Fecha y hora en formato ISO
    'dd-MM-yyyy HH:mm:ss',           // Formato personalizado con día, mes, año y hora
    'MM/dd/yyyy HH:mm:ss',           // Formato personalizado con mes, día, año y hora
    'EEE, dd MMM yyyy HH:mm:ss ZZZ', // Fecha y hora en formato RFC 2822
    'yyyy/MM/dd',                    // Formato con barras diagonales
    'dd/MM/yyyy',                    // Formato personalizado con día, mes y año
    'MM-dd-yyyy',                    // Formato personalizado con mes, día y año
    'MMM dd, yyyy',                  // Formato con nombre del mes abreviado
    'MMMM dd, yyyy',                 // Formato con nombre completo del mes
    'dd MMM, yyyy',                  // Formato con día y nombre del mes abreviado
    'dd MMMM, yyyy',                 // Formato con día y nombre completo del mes
    'MMM dd, yyyy HH:mm:ss',         // Formato con nombre del mes abreviado y hora
    'MMMM dd, yyyy HH:mm:ss',        // Formato con nombre completo del mes y hora
    'dd MMM, yyyy HH:mm:ss',         // Formato con día, nombre del mes abreviado y hora
    'dd MMMM, yyyy HH:mm:ss',        // Formato con día, nombre completo del mes y hora
    'yyyy',                          // Año de cuatro dígitos
    'yy'                             // Año de dos dígitos
];

export const parseDate = (dateInput, format) => {
    if (typeof dateInput === "string") {
        if (format) {
            const luxonDateTime = DateTime.fromFormat(dateInput, format);

            if (luxonDateTime.isValid) {
                return luxonDateTime.toJSDate();
            }
        } else {
            for (const dateFormat of dateFormats) {
                const luxonDateTime = DateTime.fromFormat(dateInput, dateFormat);

                if (luxonDateTime.isValid) {
                    return luxonDateTime.toJSDate();
                }
            }

            const luxonDateTimeSQL = DateTime.fromSQL(dateInput);
            const luxonDateTimeISO = DateTime.fromISO(dateInput);
            const luxonDateTimeHTTP = DateTime.fromHTTP(dateInput);
            const luxonDateTimeRFC2822 = DateTime.fromRFC2822(dateInput);

            if (luxonDateTimeSQL.isValid) {
                return luxonDateTimeSQL.toJSDate();
            }

            if (luxonDateTimeISO.isValid) {
                return luxonDateTimeISO.toJSDate();
            }

            if (luxonDateTimeHTTP.isValid) {
                return luxonDateTimeHTTP.toJSDate();
            }

            if (luxonDateTimeRFC2822.isValid) {
                return luxonDateTimeRFC2822.toJSDate();
            }
        }
    } else if (DateTime.isDateTime(dateInput)) {
        return dateInput.toJSDate();
    } else if (dateInput instanceof Date) {
        return dateInput;
    } else {
        const luxonDateTimeMillis = DateTime.fromMillis(dateInput);
        const luxonDateTimeObject = DateTime.fromObject(dateInput);

        if (luxonDateTimeMillis.isValid) {
            return luxonDateTimeMillis.toJSDate();
        }

        if (luxonDateTimeObject.isValid) {
            return luxonDateTimeObject.toJSDate();
        }
    }

    throw new Error("Tipo de entrada no válido" + dateInput + format);
}

export const formatDate = (
    dateInput,
    stringFormat = 'dd/MM/yyyy',
    options = { locale: 'es' }
) => {
    const date = parseDate(dateInput);

    let formattedDate = DateTime.fromJSDate(date).toFormat(stringFormat, options);

    formattedDate = formattedDate.replace(/\^(\w+)/g, (_, word) => word.charAt(0).toUpperCase() + word.slice(1));
    formattedDate = formattedDate.replace(/\^/g, '');

    return formattedDate;
}


export default {
    addMonths,
    setHours,
    addDays,
    toString,
    isWeekend,
    getMonthNameByDate,
    getMonthNamesBetweenDates,
    getFullYearsBetweenDates,
    parseDate,
    formatDate,
}